import vmClient from 'app/services/vmClient';
import { Entity, IEntityType } from 'app/types/entity';
import { DialogEntry, IDialogEntry } from 'app/constants/schemas/DialogEntry';
import { Section, ISection } from 'app/constants/schemas/Section';

export type DialogSectionType = ISection & {
  associations: {
    dialogEntries: IDialogEntry[];
  };
};

export type DialogSection = Entity<DialogSectionType>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DialogSection: IEntityType<DialogSectionType> = vmClient.defineClass({
  typeName: 'DialogSection',
  version: 8,
  lockable: true,
  persisted: true,
  extends: Section,
  associations: {
    dialogEntries: {
      type: DialogEntry,
      collection: true,
    },
  },
});
